import React from 'react';
import { Link } from 'react-router-dom';
import { EXAMPLE_ADS } from '../content/exampleAds';
import styles from './Discover.module.css';

export default function Discover() {
  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Three finished spots</h1>
        <p className={styles.subtitle}>
          A gym, a restaurant, and a realtor. Press play, then make one for your own offer.
        </p>
      </header>
      <div className={styles.list}>
        {EXAMPLE_ADS.map((ad) => (
          <article key={ad.id} className={styles.card}>
            <p className={styles.kicker}>{ad.business}</p>
            <h2 className={styles.cardTitle}>{ad.title}</h2>
            <audio className={styles.audio} controls preload="none" src={ad.src}>
              <a href={ad.src}>Play {ad.title}</a>
            </audio>
            <p className={styles.script}>{ad.script}</p>
          </article>
        ))}
      </div>
      <p className={styles.cta}>
        <Link to="/create" className={styles.ctaLink}>Make a voice ad</Link>
      </p>
    </main>
  );
}
